import React, { useContext } from 'react';
import { bool, arrayOf, shape } from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { SwapItem } from '@thd-olt-component-react/swap-item';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import { ProductSetContext } from '../../context/ProductSetContext';
import { LoaderOverlay } from '../Loader/LoaderOverlay';
import './empty-container.scss';

export const EmptyContainer = ({
  products,
  isLoading
}) => {
  const { addNewGroup } = useContext(ProductSetContext);
  const { defaultVariables } = useContext(QueryContext) || {};
  const removedItem = products.find((product) => product.removed && product.active);
  const hasGroup = !!removedItem.info?.productGroup;

  const addItem = (newItem) => {
    addNewGroup(products, [newItem.product], removedItem.info?.productGroup || removedItem.itemId);
  };

  const newDefaultVariables = {
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const EmptyContainerElement = (
    <Row className="empty-container" data-testid="empty-container">
      <LoaderOverlay isLoading={isLoading} />
      <Col fallback="3">
        <div className="empty-container__image-container">
          <span className="empty-container__mixin" />
        </div>
      </Col>
      <Col fallback="9" className="empty-container__text-container">
        <h3>Add {hasGroup ? removedItem.info.productGroup.replace(/.$/, '') : 'Product'}</h3>
      </Col>
    </Row>
  );

  return (
    <QueryProvider
      cacheKey={'productSet-empty-container-' + removedItem.itemId}
      defaultVariables={defaultVariables}
    >
      <SwapItem
        itemId={removedItem.itemId}
        onSwap={addItem}
        closeOnSwap
        customElement={EmptyContainerElement}
        selectionButtonContent="Select This Item"
        currentItemSelectable
      />
      <hr />
    </QueryProvider>
  );
};

EmptyContainer.propTypes = {
  products: arrayOf(shape({})).isRequired,
  isLoading: bool
};

EmptyContainer.defaultProps = {
  isLoading: false
};
